import { ShareKakao } from '../types';

export const SHARE_KAKAO_OG_WIDTH = 1200;
export const SHARE_KAKAO_OG_HEIGHT = 630;

const buildKakaoShareUrl = ({
  url,
  campaign,
  content,
}: Pick<ShareKakao, 'url' | 'campaign' | 'content'>) => {
  const shareUrl = new URL(url, window.location.origin);
  shareUrl.searchParams.set('utm_source', 'kakao');
  shareUrl.searchParams.set('utm_medium', 'share');
  shareUrl.searchParams.set('utm_campaign', campaign);

  if (content) {
    shareUrl.searchParams.set('utm_content', content);
  }

  return shareUrl.toString();
};

const initKakao = () => {
  const kakao = window.Kakao;
  const appKey =
    import.meta.env.VITE_KAKAO_JAVASCRIPT_KEY ||
    import.meta.env.VITE_KAKAO_API_KEY;

  if (!kakao || !appKey) {
    return false;
  }

  if (!kakao.isInitialized()) {
    kakao.init(appKey.trim());
  }

  return kakao.isInitialized();
};

const shareKakao = ({
  title,
  description,
  imageUrl,
  url,
  campaign,
  content,
  variant = 'feed',
}: ShareKakao) => {
  if (typeof window === 'undefined' || !window.Kakao) {
    return false;
  }

  if (!initKakao()) {
    return false;
  }

  const shareUrl = buildKakaoShareUrl({ url, campaign, content });

  // 카카오 feed 이미지는 HTTPS만 허용 — http 이미지는 전송 시 "알 수 없는 오류" → text로 폴백
  const feedImageUrl = imageUrl?.startsWith('https://') ? imageUrl : undefined;

  // Kakao SDK는 잘못된 imageUrl/미등록 도메인 등에서 동기적으로 throw → 폴백을 위해 false 반환
  try {
    if (variant === 'text' || !feedImageUrl) {
      window.Kakao.Share.sendDefault({
        objectType: 'text',
        text: `${title}\n${description}`,
        link: {
          webUrl: shareUrl,
          mobileWebUrl: shareUrl,
        },
        buttonTitle: '자세히 보기',
      });

      return true;
    }

    window.Kakao.Share.sendDefault({
      objectType: 'feed',
      content: {
        title,
        description,
        imageUrl: feedImageUrl,
        imageWidth: SHARE_KAKAO_OG_WIDTH,
        imageHeight: SHARE_KAKAO_OG_HEIGHT,
        link: {
          webUrl: shareUrl,
          mobileWebUrl: shareUrl,
        },
      },
    });

    return true;
  } catch (error) {
    console.error('Kakao share failed', error);
    return false;
  }
};

export default shareKakao;
